let beforeCart = window.cart ? { ...window.cart } : {};

$(document).on("cart.requestComplete", function (event, cart) {
  // Handle added to cart (quantity being incremented)
  if (cart.item_count > beforeCart.item_count) {
    const addedItem = findChangedQuantities(cart.items, beforeCart.items);

    const items = getItem(addedItem, true);

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "ecommerce",
      event_name: "add_to_cart",
      ecommerce: {
        currency: cart.currency,
        value: items[0].price,
        items,
      },
    });
  }
  // Handle remove from cart (quantity lowered or removed button pushed)
  else {
    let quantityChange = false;
    // Check to see if item was removed from array (remove button push)
    let removedItem = findNewAndRemovedItems(
      cart.items,
      beforeCart.items
    ).removedItem;

    // Handle if no item was removed (quanitity was changed)
    if (removedItem.length === 0) {
      quantityChange = true;
      removedItem = findChangedQuantities(cart.items, beforeCart.items);
    }

    const items = getItem(removedItem, quantityChange);

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "ecommerce",
      event_name: "remove_from_cart",
      ecommerce: {
        currency: cart.currency,
        value: items[0].price,
        items,
      },
    });
  }

  beforeCart = { ...cart };
});

function findNewAndRemovedItems(currentItems, beforeItems) {
  const currentItemIds = new Set(currentItems.map((item) => item.id));
  const beforeItemIds = new Set(beforeItems.map((item) => item.id));
  return {
    newItem: currentItems.filter((item) => !beforeItemIds.has(item.id)),
    removedItem: beforeItems.filter((item) => !currentItemIds.has(item.id)),
  };
}

function findChangedQuantities(currentItems, beforeItems) {
  return currentItems.filter((currentItem) => {
    const beforeItem = beforeItems.find((item) => item.id === currentItem.id);
    return beforeItem && currentItem.quantity !== beforeItem.quantity;
  });
}

function getItem(items, quantityChange) {
  const item = items[0] || [];
  return [
    {
      item_id: item.sku,
      item_name: item.title,
      item_category: item.product_type,
      index: 0,
      item_variant: item.variant_title,
      price: quantityChange
        ? Number((Number(item.line_price) / 100 / item.quantity).toFixed(2))
        : Number((Number(item.line_price) / 100).toFixed(2)),
      quantity: quantityChange ? 1 : item.quantity,
    },
  ];
}
